<template>
  <popup-menu
    anchor-position="top-right"
    @opened="searchMenuOpened"
    :opened="opened"
  >
    <img src="../../../images/icons/search.svg" slot="trigger" />
    <form
      @submit="search"
      class="search-panel"
      :class="{ 'search-panel-mobile': rootStore.isMobile }"
      @click.stop
    >
      <span>
        <input
          type="text"
          v-model="searchString"
          placeholder="zoekterm"
          @click.stop=""
          @keydown.enter="search"
          ref="search"
        />
        <img src="../../../images/icons/search.svg" @click="search" />
      </span>
      <span
        @click.stop="setSearchOption(THIS_FOLDER)"
        :class="{ disabled: allArchivesOnly || preventSelection }"
      >
        <select-box
          :selected="searchOptions.searchOption === THIS_FOLDER"
          @action="setSearchOption(THIS_FOLDER)"
          :disabled="allArchivesOnly || preventSelection"
        ></select-box
        >In deze map (+ submappen)
      </span>
      <span
        @click.stop="setSearchOption(THIS_ARCHIVE)"
        :class="{ disabled: allArchivesOnly || preventSelection }"
      >
        <select-box
          :selected="searchOptions.searchOption === THIS_ARCHIVE"
          @action="setSearchOption(THIS_ARCHIVE)"
          :disabled="allArchivesOnly || preventSelection"
        ></select-box
        >In dit archief
      </span>
      <span
        @click.stop="setSearchOption(ALL_ARCHIVES)"
        :class="{ disabled: allArchivesOnly || preventSelection }"
      >
        <select-box
          :selected="searchOptions.searchOption === ALL_ARCHIVES"
          @action="setSearchOption(ALL_ARCHIVES)"
          :disabled="allArchivesOnly || preventSelection"
        ></select-box
        >In alle archieven
      </span>
      <hr />
      <span @click="toggleIncludeTrash">
        <select-box
          :selected="searchOptions.includeTrash"
          @action="toggleIncludeTrash"
        ></select-box
        >Zoek ook in prullenmand
      </span>
      <span class="footer-text">Powered by Elasticsearch</span>
    </form>
  </popup-menu>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import SearchMixin from '@/features/filestore/SearchMixin'

export default {
  name: 'SearchMenu',
  props: {
    archiveId: Number,
    folderId: Number,
    allArchivesOnly: {
      type: Boolean,
      default: false
    },
    preventSelection: {
      type: Boolean,
      default: false
    }
  },
  mixins: [SearchMixin],
  data() {
    return {
      searchString: '',
      THIS_FOLDER: 0,
      THIS_ARCHIVE: 1,
      ALL_ARCHIVES: 2,
      opened: false
    }
  },
  watch: {},
  mounted() {
    if (this.allArchivesOnly) {
      this.fileStoreStore.setSearchOptions({
        searchOption: this.ALL_ARCHIVES
      })
    }
  },
  computed: {
    ...mapStores(useFileStoreStore),
    searchOptions() {
      return this.fileStoreStore.searchOptions
    }
  },
  methods: {
    searchMenuOpened() {
      this.opened = true

      // Set focus after animation has finished
      setTimeout(() => {
        this.$refs.search.focus()
      }, 300)
    },
    setSearchOption(value) {
      let folderId

      switch (value) {
        case this.THIS_FOLDER: {
          folderId = this.folderId
          break
        }
        case this.THIS_ARCHIVE: {
          const archive = this.fileStoreStore.getArchive(this.archiveId)
          folderId = archive.folderId
          break
        }
      }

      this.fileStoreStore.setSearchOptions({
        searchOption: value,
        folderId: folderId
      })
    },
    toggleIncludeTrash() {
      this.fileStoreStore.setSearchOptions({
        includeTrash: !this.searchOptions.includeTrash
      })
    },
    async search(e) {
      e.preventDefault()
      await this.startSearch(this.searchString)

      this.$emit('search-completed')
      this.opened = false
    }
  }
}
</script>

<style scoped lang="scss">
@use '../../../sass/base/_colors.scss' as *;

.search-panel {
  padding: 10px 10px 40px;
  display: flex;
  flex-direction: column;
  width: 220px;

  .disabled {
    color: $main-disabled;
    cursor: auto;
  }

  input {
    width: 170px;
  }

  svg {
    vertical-align: middle;
  }

  span {
    line-height: 31px;
    color: rgb(97, 97, 97);
    cursor: pointer;
  }

  hr {
    margin: 8px 0;
    background-color: #e6e6e6;
    border: none;
    height: 1px;
  }

  .footer-text {
    position: absolute;
    bottom: 2px;
    right: 12px;
    font-style: italic;
    color: #a0a0a0;
  }

  font-weight: 300;

  .search-panel-mobile {
    width: 100vw;

    input {
      width: calc(100vw - 50px);
    }
  }
}
</style>
